<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-2">
            <h1 class="m-0">Müşteri Arama</h1>
          </div>

          <div class="col-md-8">
            <form @submit.prevent="search">
              <div class="input-group">
                <input
                  type="search"
                  @blur="$v.code.$touch()"
                  v-model="$v.code.$model"
                  class="form-control"
                  placeholder="Müşteri ID"
                  :class="{ 'is-invalid': $v.code.$error }"
                />

                <select
                  v-model="site"
                  @change="siteChange"
                  class="form-control col-3"
                >
                  <option
                    v-for="item in $store.getters.getSites"
                    :key="item.slug"
                    :value="item.slug"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <div class="input-group-append">
                  <button
                    type="button"
                    @click="search"
                    class="btn btn-default"
                    :disabled="$v.$invalid"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
              <small
                v-if="!$v.code.required && $v.code.$error"
                class="form-text text-danger"
                >Bu alan zorunludur...</small
              >
              <!-- <small v-if="!$v.code.numeric" class="form-text text-danger"
                >Lütfen sadece rakam giriniz...</small
              >-->

              <small
                v-if="!$v.code.minLength && $v.code.$error"
                class="form-text text-danger"
                >Lütfen müşteri ID en az
                {{ $v.code.$params.minLength.min }} karakterden oluşmalıdır...
              </small>
              <small
                v-if="!$v.code.maxLength && $v.code.$error"
                class="form-text text-danger"
                >Lütfen müşteri ID en fazla
                {{ $v.code.$params.maxLength.max }} karakterden oluşmalıdır...
              </small>
            </form>
          </div>
          <!-- /.col -->
          <div class="col-sm-2">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"
                ><a>Anasayfa</a></router-link
              >
              <li class="breadcrumb-item active">Müşteri Arama</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <router-view :customer="customer"></router-view>
            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      site: this.$store.getters.getSite,
      code: "",
      customer: [],
    };
  },
  validations: {
    code: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(15),
      //numeric,
    },
  },
  methods: {
    search() {
      if (this.$v.$invalid) return;

      if (window.location.hash != "#/customer-search")
        this.$router.push("/customer-search/");
      

      this.$http
        .post("Customer/SearchCustomer", {
          code: this.code.trim(),
          site: this.site,
        })
        .then(
          (response) => {
            this.customer = response.data;
            this.$router.push("/customer-search/detail");
          },
          (err) => {
            this.$router.push("/customer-search/not-found");
          }
        );
    },
    siteChange() {
      this.$store.commit("setSite", this.site);
    },
  },
  created() {
    if (this.$route.params.id != null) {
      this.code = this.$route.params.id;
      this.search();
    }
  },
  watch: {
    "$store.getters.getSite"() {
      this.site = this.$store.getters.getSite;
    },

    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Customer/CustomerSearch.vue